import {Kind} from "@/model/tennant/Kind";
import {BankAccountResponse} from "@/types/service-response";

export default class BankAccount {
    private constructor(
        readonly id: string,
        readonly kind: Kind,
        readonly iban: string
    ) {
    }

    public static createBankAccount(responseNewBank: BankAccountResponse): BankAccount {
        return new BankAccount(
            responseNewBank.id,
            responseNewBank.kind,
            responseNewBank.iban
        )
    }
}